export default "__VITE_ASSET__BbXJyyGD__"